import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import DashSidebar from '../components/template/private/DashSidebar';
import DashNavbar from '../components/template/private/DashNavbar';
import AdminRoute from '../components/routes/AdminRoute';
import MetaManager from '../components/common/MetaManager';

const DashLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isSidebarOpen]);

  return (
    <AdminRoute>
      <MetaManager />
      <main className="h-screen overflow-hidden bg-gray-100">
        <DashSidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className="h-full lg:pl-64">
          <DashNavbar toggleSidebar={toggleSidebar} isOpen={isSidebarOpen} />
          <div className="h-full overflow-y-auto pt-18">
            <Outlet />
          </div>
        </div>
      </main>
    </AdminRoute>
  );
};

export default DashLayout;
